import axiosInstance from "../instance/AxiosInstance";
export const serviceViewEffect = async (payload) => {
  try {
    const response = await axiosInstance.get(
      `/services/getservice?service_id=${payload}`
    );
    return response;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Fetch Service";
  }
};
export const serviceViewAllEffect = async (payload) => {
  const params = {};

  if (payload.search) {
    params.pagination_required = true;
    params.pagesize = payload.pagesize;
    params.pageNo = payload.pageNo;
    params.search = payload.search;
    params.approoved_status = payload.approoved_status;
    if (payload.search_by && payload.search_by.trim() !== "") {
      params.search_by = payload.search_by;
    }
  } else {
    params.pagination_required = true;
    params.pagesize = payload.pagesize;
    params.pageNo = payload.pageNo;
    params.approoved_status = payload.approoved_status;
  }
  try {
    const response = await axiosInstance.get(`/services/list`, { params });

    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Fetch Services";
  }
};
export const fetchAllServiceEffect = async () => {
  try {
    const response = await axiosInstance.get(`/services/list`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Fetch Services";
  }
};

export const serviceAddEffect = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "/services/insertservice",
      payload
    );
   
    return response.data;
  } catch (error) {
    throw error || "Failed to Add Service";
  }
};
export const serviceUpdateEffect = async (payload) => {
  try {
    const response = await axiosInstance.put(
      `/services/updateService/${payload.id}`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Updata Service";
  }
};
export const serviceDeleteEffect = async (payload) => {
  try {
    const response = await axiosInstance.delete(
      `/services/deleteservice/${payload}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Delete Service";
  }
};
export const serviceApprovalEffect = async ({
  serviceId,
  status,
  rejectionReason,
}) => {
  try {
    const response = await axiosInstance.put(`/services/approve/${serviceId}`, {
      approval_status: status,
      rejection_reason: rejectionReason,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to update approval status";
  }
};
